export const chainIds = {
	1: {
		name: "Mainnet",
		link: "https://etherscan.io/address/",
	},
	3: {
		name: "Ropsten",
		link: "https://ropsten.etherscan.io/address/",
	},
	4: {
		name: "Rinkeby",
		link: "https://rinkeby.etherscan.io/address/",
	},
	5: {
		name: "Goerli",
		link: "https://goerli.etherscan.io/address/",
	},
	42: {
		name: "Kovan",
		link: "https://kovan.etherscan.io/address/",
	},
	11155111: {
		name: "Sepolia",
		link: "https://sepolia.etherscan.io/address/",
	},
};
